import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController,NavController } from '@ionic/angular';
import { DataService } from '../../services/data.service';
import { EngLaService } from '../../propertiesFile/eng-la.service';
import { FrnLaService } from '../../propertiesFile/frn-la.service';
@Component({
  selector: 'app-alter-popover',
  templateUrl: './alter-popover.page.html',
  styleUrls: ['./alter-popover.page.scss'],
})
export class AlterPopoverPage implements OnInit {
  dispmsg;
  alertind;
  lO;
  dXLan1;
  dL;
  constructor(private navParams: NavParams, 
    private popoverController: PopoverController,
    private navCtrl:NavController,
    public ds:DataService,
    private en:EngLaService,
    private fr:FrnLaService) {
        this.dispmsg = this.navParams.get('dispmsg');
        this.alertind = this.navParams.get('custom_id');
        this.kroCheck();
   }
  ngOnInit() {
  }
  doChange(ev, ind) {
    if(ind==='Edit'){
      this.ds.setNavPath('client-basic-input');
      this.popoverController.dismiss();
    }
    else if(ind==='QuoteCompare'){
      this.ds.setNavPath('quote-compare');
      this.popoverController.dismiss();
    }
    else{
      this.ds.setNavPath('');
      this.popoverController.dismiss();
    }
  }
  kroCheck() {
    this.lO = this.ds.getLan();
    if (this.lO === 'eng') {
      this.dXLan1 = this.en.getCinf();
      this.dL = this.en.getQD();
    } else if (this.lO === 'frn') {
      this.dXLan1 = this.fr.getCinf();
      this.dL = this.fr.getQD();
    }
  }
}
